module.exports = __webpack_public_path__ + "img/shop_haier_top.7f8e286b.png";